<template>
  <div class="solution2 aboutUs">
    <!--1:banner-->
    <div class="banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay2s:true}">智慧新安全 构筑新未来</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay4s:true}">
              牛盾网络始终坚持站在用户的角度，不断创新，为客户提供更优质的互联网服务。
            </div>
          </div>
        </div>
        <div class="tab_wrap">
          <el-tabs v-model="activeName">
            <el-tab-pane label="公司简介" name="first">
              <div class="pane company">
                <!--1:-->
                <div class="block S_block1">
                  <p class="title">专业、可靠的安全技术服务公司</p>
                  <p class="txt">&nbsp;&nbsp;&nbsp;&nbsp;杭州牛盾网络技术有限公司创立于2016年初，是一家兼具CDN与云服务双牌照的信息安全产品和服务解决方案的提供商，专注于提供行业领先的互联网安全一站式服务，致力于协同政府、帮助企业和个人创建安全、可信的网络环境。公司坚持技术创新，拥有一支来自行业顶尖科研人才组成的技术研发团队。公司创始人兼CEO高春龙毕业于清华大学电气自动化和美国卡耐基梅隆大学计算机专业，留美期间在洛克希德马丁及IBM公司从事网络安全相关工作，回国后在国家安全部门从事网络安全工作十余年。</p>
                  <p class="txt" style="margin-top:30px;">&nbsp;&nbsp;&nbsp;&nbsp;成立两年多以来，牛盾网络一直以超强的自主研发能力不断创新，依托网站秒封秒解、全时漏洞扫描、安全渗透测试、基于RFID的物联网应用等核心技术开展服务，率先提出了“以攻代防”、“物联网+保险”等安全新逻辑，并在“众安保险港股上市为千亿市值护航”、“新网银行企业银行安全渗透”、“物联网安全助力都邦保险解决理赔难题”等项目中得到客户充分肯定。公司目前已与政务、金融、保险等行业多家客户达成深度合作。</p>
                  <ul class="ul_company flex_between">
                    <li class="flexCol_center">
                      <b>8</b>
                      <h4>张牌照</h4>
                      <p>业内最短时间内获得行业全牌照资质的企业之一，多重保障，值得信赖。</p>
                    </li>
                    <li class="flexCol_center">
                      <b>20+</b>
                      <h4>社会服务</h4>
                      <p>立足社会需求，为科技创新提供强大引擎，致力于用安全技术解决社会问题。</p>
                    </li>
                    <li class="flexCol_center">
                      <b>500+</b>
                      <h4>专家服务</h4>
                      <p>为行业用户提供定制化的安全解决方案，结合资深安全专家服务，保障业务和数据安全。</p>
                    </li>
                    <li class="flexCol_center">
                      <b>10<span style="font-size: 36px;">万+</span></b>
                      <h4>次安全检测</h4>
                      <p>从黑客视角看待安全问题，对网站/主机进行多维度的安全检测，先黑客一步发现问题并快速解决。</p>
                    </li>

                  </ul>
                </div>
                <!--2:-->
                <div class="block S_block2">
                  <div class="content">
                    <swiper :options="swiperOption2" class="">
                      <swiper-slide>
                        <div class="slider1_bg1">
                          <div class="sd_wrap">
                            <p>我们的愿景</p>
                            <p class="txt">创造透明、可信、安全的互联网生态</p>
                          </div>
                        </div>
                      </swiper-slide>
                      <swiper-slide>
                        <div class="slider1_bg2">
                          <div class="sd_wrap">
                            <p>我们的使命</p>
                            <p class="txt">让互联网更安全</p>
                          </div>
                        </div>
                      </swiper-slide>
                      <swiper-slide>
                        <div class="slider1_bg2">
                          <div class="sd_wrap">
                            <p>价值观</p>
                            <p class="txt">让技术更有价值，让用户更有安全感</p>
                          </div>
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
                <!--3:-->
                <div class="block S_block3">
                  <p class="title">社会价值</p>
                  <p class="s3_describe">用网络安全保护社会，用科技能力创造价值</p>
                  <div class="content apply_swiper">
                    <swiper :options="swiperOption" class="swiperContainer">
                      <swiper-slide>
                        <div class="slider slider1">
                          <div class="slider_box">
                            <div class="cont flexCol_aroud">
                              <p :class="{tit:true,}">培养网安人才</p>
                              <p :class="{detail:true,}">
                                引导网安领域人才用正确的方式利用自身技术为社会创造价值，为中国的网络安全事业贡献自己的力量。</p>
                            </div>
                            <div class="btn_wrap">
                              <div class="swiper-button-prev"></div>
                              <div class="swiper-button-next"></div>
                            </div>
                          </div>
                        </div>
                      </swiper-slide>
                      <swiper-slide>
                        <div class="slider slider2">
                          <div class="slider_box">
                            <div class="cont flexCol_aroud">
                              <p class="tit">避免经济损失</p>
                              <p class="detail">为政务、游戏、金融、教育等行业用户提供个性化、全方位的安全防御解决方案，避免由于网络安全问题而遭受大额的经济损失。</p>
                            </div>
                            <div class="btn_wrap">
                              <div class="swiper-button-prev"></div>
                              <div class="swiper-button-next"></div>
                            </div>
                          </div>
                        </div>
                      </swiper-slide>
                      <swiper-slide>
                        <div class="slider slider3">
                          <div class="slider_box">
                            <div class="cont flexCol_aroud">
                              <p class="tit">维护社会稳定</p>
                              <p class="detail">公司积极响应国家政策号召，坚持自主创新，利用安全技术助推社会治理，助力中国早日成为网络强国。</p>
                            </div>
                            <div class="btn_wrap">
                              <div class="swiper-button-prev"></div>
                              <div class="swiper-button-next"></div>
                            </div>
                          </div>
                        </div>
                      </swiper-slide>
                      <swiper-slide>
                        <div class="slider slider4">
                          <div class="slider_box">
                            <div class="cont flexCol_aroud">
                              <p class="tit">智慧城市建设</p>
                              <p class="detail">随着智慧城市建设的推进，所有技术的实施都依托于网络，因此网络安全成为保障智慧城市建设的重中之重。</p>
                            </div>
                            <div class="btn_wrap">
                              <div class="swiper-button-prev"></div>
                              <div class="swiper-button-next"></div>
                            </div>
                          </div>
                        </div>
                      </swiper-slide>
                      <div class="pag" slot="pagination"><p class="icon_pag"></p></div>
                    </swiper>
                  </div>
                </div>
              </div>
              <!--foot-->
              <div class="foot">
                <footBar></footBar>
              </div>
            </el-tab-pane>
            <el-tab-pane label="资质荣誉" name="second">
              <div class="pane glory">
                <div class="block g_block1">
                  <p class="txt_title">短短三年间，牛盾网络从初创到成长，已逐渐蜕变为行业内创新型典范。凭借强大的技术研发实力，公司现已拥有知识产权10余项，共获荣誉资质奖项30余项。未来，牛盾网络将继续在网络安全领域深耕技术，全力打造值得用户信赖的安全技术服务公司！</p>
                  <p class="title">企业荣誉</p>
                  <ul class="ul_box flex_around">
                    <li>
                      <span class="glory_bg glory_bg00"></span>
                      <p class="txt_describe">2018年度新锐杭商</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg11"></span>
                      <p class="txt_describe">2018国际众创大会“新秀十佳创业者”</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg10"></span>
                      <p class="txt_describe">“奇思妙想浙江行”2018创业大赛总决赛三等奖</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg02"></span>
                      <p class="txt_describe">2018年杭州市科技型初创企业培育工程入选企业</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg05"></span>
                      <p class="txt_describe">浙江省互联网协会会员单位</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg09"></span>
                      <p class="txt_describe">创业企业观察点</p>
                    </li>
                  </ul>
                  <ul class="ul_box flex_around">
                    <li>
                      <span class="glory_bg glory_bg17"></span>
                      <p class="txt_describe">第三届“中国创翼”创业创新大赛全国赛创翼之星奖</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg08"></span>
                      <p class="txt_describe">2018年“网鼎杯”网络安全大赛50强</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg13"></span>
                      <p class="txt_describe">2018年“网鼎杯”网络安全大赛线上赛三等奖</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg03"></span>
                      <p class="txt_describe">第三届“中国创翼”创业创新大赛浙江赛区选拔赛一等奖</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg04"></span>
                      <p class="txt_describe">杭州市高新技术企业</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg07"></span>
                      <p class="txt_describe">杭州余杭区科技企业研发中心</p>
                    </li>
                  </ul>
                  <ul class="ul_box flex_around">
                    <li>
                      <span class="glory_bg glory_bg01"></span>
                      <p class="txt_describe">中国互联网协会会员单位</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg15"></span>
                      <p class="txt_describe">2018中国云计算领域值得信赖品牌</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg16"></span>
                      <p class="txt_describe">浙江省科技型中小企业</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg12"></span>
                      <p class="txt_describe">国家科技型中小企业</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg06"></span>
                      <p class="txt_describe">上海区块链企业发展促进联盟始发成员单位</p>
                    </li>
                    <li>
                      <span class="glory_bg glory_bg18"></span>
                      <p class="txt_describe">2017创变新势力</p>
                    </li>
                  </ul>
                </div>
                <div class="block g_block2">
                  <p class="title">企业资质</p>
                  <div class="wrap">
                    <ul class="ul_box flex_between">
                      <li>
                        <div class="bg_lf bg_lf01"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf02"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf03"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf04"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf05"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf06"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf07"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf08"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf09"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf11"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf12"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf13"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf14"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf15"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf16"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf17"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf18"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf19"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf20"></div>
                      </li>
                      <li>
                        <div class="bg_lf bg_lf01"></div>
                      </li>

                    </ul>
                  </div>
                </div>
                <!--foot-->
                <div class="foot">
                  <footBar></footBar>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="合作伙伴" name="third">
              <div class="pane teamwork">
                <div class="block t_block1">
                  <p class="title">合作支持</p>
                  <div class="wrap">
                    <ul class="ul_box flex_between">
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg01"></span>
                        <i class="icon icon_team01"></i>
                        <h4 class="t_title">方案咨询</h4>
                      </li>
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg02"></span>
                        <i class="icon icon_team02"></i>
                        <h4 class="t_title">技术支持</h4>
                      </li>
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg03"></span>
                        <i class="icon icon_team03"></i>
                        <h4 class="t_title">实施指导</h4>
                      </li>
                    </ul>
                    <ul class="ul_box flex_between">
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg04"></span>
                        <i class="icon icon_team04"></i>
                        <h4 class="t_title">代运维服务</h4>
                      </li>
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg05"></span>
                        <i class="icon icon_team05"></i>
                        <h4 class="t_title">市场支持</h4>
                      </li>
                      <li class="flexCol_aroud item1">
                        <span class="icon_bg icon_bg06"></span>
                        <i class="icon icon_team06"></i>
                        <h4 class="t_title">商机转达</h4>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="block t_block2">
                  <p class="title">合作伙伴</p>
                  <div class="wrap">
                    <ul class="ul_box flex_around ">
                      <li>
                        <div class="icon icon_t1"></div>
                      </li>
                      <li>
                        <div class="icon icon_t2"></div>
                      </li>
                      <li>
                        <div class="icon icon_t3"></div>
                      </li>
                      <li>
                        <div class="icon icon_t4"></div>
                      </li>
                      <li>
                        <div class="icon icon_t5"></div>
                      </li>
                    </ul>
                    <ul class="ul_box flex_around">
                      <li><i class="icon icon_t6"></i></li>
                      <li><i class="icon icon_t7"></i></li>
                      <li><i class="icon icon_t8"></i></li>
                      <li><i class="icon icon_t9"></i></li>
                      <li><i class="icon icon_t10"></i></li>
                    </ul>
                    <ul class="ul_box flex_around">
                      <li><i class="icon icon_t11"></i></li>
                      <li><i class="icon icon_t12"></i></li>
                      <li><i class="icon icon_t13"></i></li>
                      <li><i class="icon icon_t14"></i></li>
                      <li><i class="icon icon_t15"></i></li>
                    </ul>
                    <ul class="ul_box flex_around">
                      <li><i class="icon icon_t16"></i></li>
                      <li><i class="icon icon_t17"></i></li>
                      <li><i class="icon icon_t18"></i></li>
                      <li><i class="icon icon_t19"></i></li>
                      <li><i class="icon icon_t20"></i></li>
                    </ul>
                    <ul class="ul_box flex_around">
                      <li><i class="icon icon_t21"></i></li>
                      <li><i class="icon icon_t22"></i></li>
                      <li><i class="icon icon_t26"></i></li>
                      <li><i class="icon icon_t24"></i></li>
                      <li><i class="icon icon_t25"></i></li>
                    </ul>
                    <!--<ul class="ul_box flex_between" style="margin-left:10px;">-->
                      <!--<li><i class="icon icon_t26"></i></li>-->
                    <!--</ul>-->
                  </div>
                </div>
                <!--foot-->
                <div class="foot">
                  <footBar></footBar>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="联系我们" name="fourth">
              <div class="pane contact">
                <div class="block c_block1">
                  <div class="bg_wrap">
                    <div class="box flexCol_aroud">
                      <p class="txt_box1"><i class="icon icon_dingwei"></i>杭州牛盾网络技术有限公司</p>
                      <p class="txt_box2">公司地址：浙江省杭州市余杭区仓前街道文一西路1001号 衢时代D座3层</p>
                      <div class="flex_between" style="align-items:flex-end;">
                        <div class="flexCol_aroud">
                          <p>客服电话：</p>
                          <p>0571-8861-6565</p>
                        </div>
                        <span class="icon_contact"></span>
                      </div>
                    </div>
                  </div>
                  <ul class="ul_box flex_around">
                    <li class="flex_between">
                      <div class="flexCol_center">
                        <h4 class="txt_china">商务合作</h4>
                        <p class="txt_eng">market@newdun.com</p>
                      </div>
                      <span class="icon_c icon_c01"></span>
                    </li>
                    <li class="flex_between">
                      <div class="flexCol_center">
                        <h4 class="txt_china">媒体合作</h4>
                        <p class="txt_eng">market@newdun.com</p>
                      </div>
                      <span class="icon_c icon_c02"></span>
                    </li>
                    <li class="flex_between">
                      <div class="flexCol_center">
                        <h4 class="txt_china">技术合作</h4>
                        <p class="txt_eng">support@newdun.com</p>
                      </div>
                      <span class="icon_c icon_c03"></span>
                    </li>
                  </ul>
                </div>
                <div class="block c_block2">
                  <div class="content">
                    <p class="title">留言咨询</p>
                    <el-form ref="form" :model="form" class="form" :rules="rules">
                      <div class="flex_between">
                        <el-form-item prop="company">
                          <span class="label">公司名称：</span>
                          <el-input v-model="form.company"></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile">
                          <span class="label">联系电话：</span>
                          <el-input v-model="form.mobile"></el-input>
                        </el-form-item>
                      </div>
                      <div class="s_wrap">
                        <p class="txt_title">想了解的产品</p>
                        <div class="flex_align">
                          <el-radio v-model="product" label="0" border @change="changeCheck(0)">渗透测试</el-radio>
                          <el-radio v-model="product" label="1" border @change="changeCheck(1)">专家服务</el-radio>
                          <el-radio v-model="product" label="2" border @change="changeCheck(2)">未备案域名阻断系统</el-radio>
                          <el-radio v-model="product" label="3" border @change="changeCheck(3)">网站全时安全管控平台</el-radio>
                        </div>
                      </div>
                      <div class="s_wrap" style="margin-top:20px;">
                        <p class="txt_title">详细描述</p>
                        <el-form-item prop="description">
                          <el-input type="textarea" v-model="form.description"></el-input>
                        </el-form-item>
                      </div>
                      <el-form-item class="flex_center">
                        <div class="button_submit"  @click="onSubmit('form')">提交</div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <!--foot-->
                <div class="foot">
                  <footBar></footBar>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import {contact} from "../api/api"
  import footBar from '../components/footerbar'
  import returnTop from '../components/returnTop'
  import Case from '../components/case'

  export default {
    name: "product2",
    data() {
      return {
        dialogVisible: false,
        product: '0',
        rules: {
          company: [
            {required: true, message: '公司名称不能为空', trigger: 'blur'},
          ],
          product: [
            {required: true, message: '请选择产品', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码输入有误', trigger: 'blur'}
          ],
          description: [
            {required: true, message: '需求描述不能为空', trigger: 'blur'},
          ],
        },
        form:{
          company:'',
          mobile:'',
          product:0,
          description:'',
        },
        activeName: 'first',
        swiperOption: {
          autoplay: true,
          speed: 500,
          loop: true,
          type: 'custom',
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          },
          pagination: {
            el: '.pag',
            bulletElement: "li",
          }
        },
        swiperOption2: {
          autoplay: true,
          /*speed: 3000,*/
          loop: true,
          pagination: '.swiper-pag',
        },
        isUp: false,
        isUp1: false,
        isUp2: false,
        isUp3: false,
        isDisplay1: true,
        isDisplay2: true,
        isDisplay3: true,
      }
    },
    components: {
      footBar, Case,returnTop
    },
    mounted() {
      this.isUp = true;
      // console.log(this.$route.params.tabName);
      if(this.$route.params.tabName){
        this.activeName = this.$route.params.tabName;
      }else{
        this.activeName = 'first';
      }
    },
    methods: {
      changeCheck(n){//check变化
      },
      onSubmit(formName){//提交
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params ={
              company:this.form.company,
              mobile:this.form.mobile,
              product:this.product,
              description:this.form.description,
            };
            contact(params).then(res=>{
              if(res.data.code==1){//succ
                this.$message({type:'success',message:"我们已收到您的信息，客服会尽快与您联系"});
                this.form = {};
              }else{
                // this.$message({type:'error',message:res.data.message})
              }
            })
          } else {
            return false;
          }
        });
      },
      goU(url) {
        this.$router.push({name: url});
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollFun);
    },
  }
</script>

<style scoped lang="scss">
  .t_block2{
    .wrap{
      padding-bottom:40px;
    }
  }
  .c_block2{
    .content{
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue